import axios from 'axios'

const fileValidator = {
  getMessage: (field, params, data) => {
    return data.message
  },
  validate: async (value) => {
    const headers = { 'x-validate-file-exists': true }

    const s3Pattern = /(s3-|s3\.)?(.*)\.amazonaws\.com/
    const isS3File = s3Pattern.test(value)

    if (!isS3File) {
      return {
        valid: true,
        data: { message: 'File is found' }
      }
    }

    try {
      const res = await axios.head(value, { headers })

      return {
        valid: true,
        data: { message: 'File is found' }
      }
    } catch (e) {
      return {
        valid: false,
        data: { message: 'The file is not found by the link or expired' }
      }
    }
  }
}

export default fileValidator
